module.exports = __webpack_public_path__ + "img/module.8f4fa3f4.png";